import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import InfoMessage from "../../Shared/InfoMessage";
import { computed, inject, onMounted, ref, watch } from "vue";
import {
  optionsProviderKey,
  type OptionsNavigationPath,
} from "../../../infrastructure/options_provider";
import { useRouter, useRoute } from "vue-router";
import OptionsNavigation from "../OptionsNavigation";
import OptionsPhone from "../OptionsPhone";
import OptionsMobile from "../OptionsMobile";
import OptionsAccess from "../OptionsAccess";
import OptionsTv from "../OptionsTv";
import Cart from "../../Shared/Cart";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default {
  template: html,
  components: {
    InfoMessage,
    OptionsNavigation,
    OptionsAccess,
    OptionsPhone,
    OptionsMobile,
    OptionsTv,
    Cart,
  },
  setup() {
    // Injections
    const { t } = useI18n();
    const router = useRouter();
    const route = useRoute();
    const optionsProvider = inject(optionsProviderKey);
    const optionPathes = computed<OptionsNavigationPath[]>(() => {
      return optionsProvider?.optionPathes.value ?? [];
    });
    const currentPath = computed(() => {
      const currentIndex = optionPathes.value.findIndex(
        (p) => p.path == route.path,
      );
      const current = optionPathes.value[currentIndex];
      return current;
    });

    const currentPathString = computed(() => currentPath.value?.path || "");

    // während des Klicks auf 'next' läuft validate() ggf. noch auf einen offenen
    // Autosave-Request der Kinder; solange den Button sperren (Doppelklick-Schutz + Feedback)
    const isValidating = ref(false);

    const back = function () {
      const currentIndex = optionPathes.value.findIndex(
        (p) => p.path == route.path,
      );
      const last = optionPathes.value[currentIndex - 1];
      if (last) {
        router.push(last.path);
      } else {
        router.push("/");
      }
    };

    const next = function () {
      const currentIndex = optionPathes.value.findIndex(
        (p) => p.path == route.path,
      );
      const next = optionPathes.value[currentIndex + 1];
      if (next) {
        router.push(next.path);
      } else {
        router.push("/configs");
      }
    };

    const handleOptionsPath = () => {
      if ("/options" == route.path) {
        const first = optionPathes.value[0];
        if (first) {
          router.push(first.path);
        } else {
          //router.push("/configs")
        }
      }
    };

    onMounted(() => {
      // /options is just the container -> move to the first option page
      handleOptionsPath();
    });

    watch(
      () => route.path,
      () => {
        handleOptionsPath();
      },
    );
    return {
      t,
      currentPathString,
      next,
      back,
      isValidating,
    };
  },
};
